import { render, staticRenderFns } from "./task_center_list.vue?vue&type=template&id=4d8c271d"
import script from "./task_center_list.vue?vue&type=script&lang=js"
export * from "./task_center_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports